import React from "react";
import { Navigate } from "react-router-dom";
import { chTeSessio } from "./chAuth";

// Equivalent, dins de /Control_Horari, a components/Privateroute.js de
// l'ERP general, però amb la sessió aïllada del portal mòbil.
function ControlHorariPrivat({ children }) {
  return chTeSessio() ? children : <Navigate to="/Control_Horari/login" replace />;
}

export default ControlHorariPrivat;
